/**
 * 與 backend/utils/bus-route-taxonomy.js 同步（前端僅需家族鍵）
 */
export function buildRouteFamilyId(routeUid) {
    if (!routeUid) return null;
    const prefix = String(routeUid).slice(0, 3);
    return `${prefix}-FAM-${String(routeUid).slice(3) || routeUid}`;
}
